export default {
    companyList: [], //保险公司
    search: {}, //查询数据
    tableLoading: false, //表格loading
    tabActive: '1',
    menuList: [],
    columns: [
        //表格字段
        {
            title: '考试名称',
            align: 'center',
            key: 'name',
            minWidth: 300
        },
        {
            title: '考试分类',
            key: 'columnName',
            tooltip: true,
            align: 'center',
            width: '300'
        },
        {
            title: '有效期',
            slot: 'isLong',
            align: 'center',
            width: '220'
        },
        {
            title: '是否上架',
            slot: 'isUse',
            align: 'center',
            width: '180'
        },
        {
            title: '考题数量',
            align: 'center',
            key: 'nums',
            width: '180'
        },
        {
            title: '排序',
            align: 'center',
            key: 'orderNum',
            width: '180'
        },
        {
            title: '操作',
            slot: 'action',
            align: 'center',
            width: '290',
            fixed: 'right'
        }
    ],
    tableData: [], //表格数据
    total: 0, //表格记录数
    pageSize: 10, //页容量
    pageNum: 1, //当前页
    form: {}, //表单数据
    formVisible: false //表单弹窗
};
